module.exports = __webpack_public_path__ + "src/assets/img/screen01.6aa20f14.jpg";